import React, { useState, useRef } from 'react';

const FilterBar = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [location, setLocation] = useState('');
  const [classFilter, setClassFilter] = useState('');
  const searchTimeout = useRef(null);

  const locations = [
    { value: "", label: "Select Location" },
    { value: "dhaka", label: "Dhaka" },
    { value: "chittagong", label: "Chittagong" },
    { value: "rajshahi", label: "Rajshahi" },
    { value: "sylhet", label: "Sylhet" },
    { value: "khulna", label: "Khulna" }
  ];

  const classes = [
    { value: "", label: "Select Class" },
    { value: "class-8", label: "Class 8" },
    { value: "ssc", label: "SSC" },
    { value: "hsc", label: "HSC" },
    { value: "admission", label: "Admission" }
  ];

  const handleSearch = (value) => {
    setSearchTerm(value);
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }
    searchTimeout.current = setTimeout(() => {
      console.log('Searching for:', value);
    }, 500);
  };

  const handleLocationChange = (e) => {
    const value = e.target.value;
    setLocation(value);
    console.log('Filtering for location:', value);
  };

  const handleClassChange = (e) => {
    const value = e.target.value;
    setClassFilter(value);
    console.log('Filtering for class:', value);
  };

  return (
    <div className="filter-bar">
      <div className="search-group">
        <i className="fas fa-search"></i>
        <input 
          type="text" 
          placeholder="Search by name or subject..."
          value={searchTerm}
          onChange={(e) => handleSearch(e.target.value)}
        />
      </div>
      <div className="select-group">
        <select 
          id="locationFilter" 
          value={location}
          onChange={handleLocationChange}
        >
          {locations.map((loc, index) => (
            <option key={index} value={loc.value}>{loc.label}</option>
          ))}
        </select>
      </div>
      <div className="select-group">
        <select 
          id="classFilter" 
          value={classFilter}
          onChange={handleClassChange}
        >
          {classes.map((cls, index) => (
            <option key={index} value={cls.value}>{cls.label}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default FilterBar;